const BACKGROUND_DOCUMENT_HIDDEN_CUSTOM_ACTION =
    'GIL032: El cliente ha puesto la app en segundo plano, ha bloqueado el telefono o ha perdido el foco del navegador.',
  BACKGROUND_DOCUMENT_VISIBLE_CUSTOM_ACTION =
    'GIL033: El cliente ha vuelto a poner la app en primer plano o ha recuperado el foco del navegador.';

export { BACKGROUND_DOCUMENT_HIDDEN_CUSTOM_ACTION, BACKGROUND_DOCUMENT_VISIBLE_CUSTOM_ACTION };
